import { businessService } from './business';
import { restaurantImageService, type RestaurantImage } from './restaurantImages';
import type { RestaurantWithProducts } from './restaurant.types';

export class RestaurantAvailabilityService {

  // Legacy support - migrate restaurants without business_id
  async migrateRestaurantsToBusinessStructure(): Promise<{ 
    success: boolean; 
    migrated: number; 
    error?: string 
  }> {
    try {
      return await businessService.migrateExistingRestaurants();
    } catch (error) {
      console.error('Migration error:', error);
      return { success: false, migrated: 0, error: '마이그레이션 중 오류가 발생했습니다.' };
    }
  }

  /**
   * 매장 이미지 관련 메서드들
   */

  // 매장 이미지 목록 가져오기
  async getRestaurantImages(restaurantId: string): Promise<{ success: boolean; data?: RestaurantImage[]; error?: string }> {
    return await restaurantImageService.getRestaurantImages(restaurantId);
  }

  // 매장 이미지 추가
  async addRestaurantImage(
    restaurantId: string, 
    imageFile: File, 
    userId?: string,
    description?: string
  ): Promise<{ success: boolean; data?: RestaurantImage; error?: string }> {
    return await restaurantImageService.addRestaurantImage(restaurantId, imageFile, userId, description);
  }

  // 매장 이미지 삭제
  async deleteRestaurantImage(imageId: string): Promise<{ success: boolean; error?: string }> {
    return await restaurantImageService.deleteRestaurantImage(imageId);
  }

  // 매장 이미지 순서 변경
  async updateRestaurantImageSequence(
    imageId: string, 
    newSequence: number
  ): Promise<{ success: boolean; error?: string }> {
    return await restaurantImageService.updateImageSequence(imageId, newSequence);
  }

  // 매장 대표 이미지 가져오기
  async getMainRestaurantImage(restaurantId: string): Promise<{ success: boolean; data?: RestaurantImage; error?: string }> {
    return await restaurantImageService.getMainRestaurantImage(restaurantId);
  }

  /**
   * 매장 조회 시 이미지 포함 버전
   */
  async getRestaurantWithImages(
    id: string,
    getRestaurantByIdFn: (id: string, withProducts: boolean) => Promise<{ success: boolean; data?: RestaurantWithProducts; error?: string }>
  ): Promise<{ success: boolean; data?: RestaurantWithProducts; error?: string }> {
    try {
      // 기본 매장 정보 가져오기
      const restaurantResult = await getRestaurantByIdFn(id, true);
      if (!restaurantResult.success || !restaurantResult.data) {
        return restaurantResult;
      }

      // 매장 이미지 가져오기
      const imagesResult = await this.getRestaurantImages(id);
      if (imagesResult.success && imagesResult.data) {
        restaurantResult.data.images = imagesResult.data;
      }

      return restaurantResult;
    } catch (error) {
      console.error('Get restaurant with images error:', error);
      return { success: false, error: '매장 정보를 불러오는 중 오류가 발생했습니다.' };
    }
  }
}

export const restaurantAvailabilityService = new RestaurantAvailabilityService();